/**
 * Leerzustand — eine Aufforderung, keine Meldung.
 *
 * „Noch keine Zahlungen erfasst. Zahlung erfassen." statt „Keine Daten
 * vorhanden." Ein leerer Bildschirm ohne Aufforderung gilt als unfertig
 * (`design-system`), weil er den Nutzer allein lässt: Er sieht, dass nichts da
 * ist, aber nicht, was er tun soll.
 */

import type { ReactNode } from 'react'

interface EmptyStateProps {
  /** Was fehlt, im Perfekt: „Noch keine Objekte angelegt." */
  readonly title: string
  /** Was zu tun ist, ein Satz. Optional, wenn die Aktion selbsterklärend ist. */
  readonly hint?: string
  /** Die Aufforderung als Schaltfläche. Aktives Verb, nie „Absenden". */
  readonly action?: ReactNode
  /** Kleine Gruppen innerhalb eines Formulars statt einer ganzen Liste. */
  readonly compact?: boolean
  readonly testId: string
}

export function EmptyState({ title, hint, action, testId, compact = false }: EmptyStateProps) {
  return (
    <div
      data-testid={testId}
      className={`flex flex-col items-center justify-center gap-3 px-(--page-x) text-center ${compact ? 'py-3' : 'py-8'}`}
    >
      <p className="text-section font-(--font-weight-section) text-text">{title}</p>
      {hint !== undefined && <p className="text-label max-w-prose text-muted">{hint}</p>}
      {action}
    </div>
  )
}
